<template>
  <!-- 消息提醒弹框 -->
  <div>
    <el-dialog
      :title="'导入错误信息'"
      :visible.sync="dialogVisible"
      width="30%"
      class="message-dialog abow_dialog"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div class="message-box">
        <div class="bd">
          <ul>
            <li
              v-for="(data,index) in messageData"
              :key="index"
              class="err-list"
            >
              {{ data }}
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    messageData: {
      type: Array,
      default: () => []
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    }
  }
}
</script>
<style>
.bd ul {
  padding: 5px 20px 0;
  margin: 0;
}
.err-list {
  padding: 0;
  margin: 0;
  list-style: none;
  line-height: 24px;
}
</style>
